import { render } from "./event-verify.vue?vue&type=template&id=236ffe6c&scoped=true"
import script from "./event-verify.vue?vue&type=script&lang=js"
export * from "./event-verify.vue?vue&type=script&lang=js"

import "./event-verify.vue?vue&type=style&index=0&id=236ffe6c&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236ffe6c"]])

export default __exports__